import React from 'react';
import { Switch as AntSwitch } from 'antd';
import styled from 'styled-components';
import { colorsPalette } from '../../styles/colors-palette';

type SwitchSize = 'small' | 'default';

interface SwitchProps {
  // onChange?: (checked: boolean, event?: React.MouseEvent) => void;
  checked?: boolean;
  disabled?: boolean;
  onClick?: (checked: boolean) => void;
  size?: SwitchSize;
  loading?: boolean;
  id?: string;
  className?: string;
}

function Switch({
  // onChange,
  checked,
  onClick,
  disabled,
  id,
  loading,
  className,
  size = 'default',
}: SwitchProps): JSX.Element {
  return (
    <StyledSwitch
      id={id}
      // onChange={onChange}
      checked={checked}
      onClick={(checked, event) => onClick && onClick(checked)}
      disabled={disabled}
      loading={loading}
      size={size}
      className={className}
    />
  );
}

const StyledSwitch = styled(AntSwitch)`
  --antd-wave-shadow-color: ${colorsPalette.green400};
  &.ant-switch-checked {
    background: ${colorsPalette.green400};

    &:hover:not(.ant-switch-disabled) {
      background: ${colorsPalette.green300};
    }
  }

  & {
    .ant-switch-checked {
      background: ${colorsPalette.green400};
    }
  }
`;

export default Switch;
